import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "jumbotron"
}
const _hoisted_3 = { class: "display-4" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = {
  key: 0,
  class: "row text-muted"
}
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = { class: "col-sm-3" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-sm-9 text-muted" }
const _hoisted_11 = { class: "col-sm-3" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 2,
  class: "row"
}
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = { class: "input-group input-group-sm mb-3" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "input-group-append" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-sm-3" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useResourcePage } from '@DataSharing/Shares/pages-core'
    import { copyToClipboard } from "@common/Common";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourcePage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const provider = route.params.provider as string

    const id = ref()
    const organizationUnitId = ref()
    const workspaceId = ref()
    const projectId = ref()
    const sharedBy = ref()
    const sharedWith = ref()
    const resourceProviderName = ref(provider)
    const resourceId = ref(route.params.resourceId)
    const emailsProviderName = ref()
    const emailsProviderConfig = ref()
    const copied = ref<string[]>([])

    const { useResourceSharesQuery } = useResourcePage()

    const { modelResourceSharesQueryV1, runResourceSharesQueryV1 } = useResourceSharesQuery(provider, resourceId.value)

    const shares = computed(() => modelResourceSharesQueryV1.value?.Shares || [])
    const isShared = computed(() => modelResourceSharesQueryV1.value && shares.value.length > 0)
    const newShareId = computed(() => modelResourceSharesQueryV1.value?.NewShareId)
    const organizationName = computed(() => modelResourceSharesQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelResourceSharesQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelResourceSharesQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelResourceSharesQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelResourceSharesQueryV1.value?.ResourceUrl)
    const manageUrl = computed(() => modelResourceSharesQueryV1.value?.ManageUrl)

    const sharesExt = computed(() => shares.value.map(_ => Object.assign({}, _, {
        Copied: copied.value.find(c => c == _.ShareId) != undefined
    })))

    function handleCopyToClipboard(share: any) {
        copyToClipboard(share.ShareUrl)
        copied.value.push(share.ShareId)

        const h = setTimeout(() => {{
            copied.value = copied.value.filter(_ => _ != share.ShareId)
            clearTimeout(h)
        }}, 1000)
    }

    onMounted(() => runResourceSharesQueryV1())

    watch(modelResourceSharesQueryV1, () => {
        const model = modelResourceSharesQueryV1.value
        id.value = model?.ShareId
        organizationUnitId.value = model?.OrganizationUnitId
        workspaceId.value = model?.WorkspaceId
        projectId.value = model?.ProjectId
        sharedBy.value = model?.AuthenticatedEmail
        emailsProviderName.value = model?.EmailsProviderName
        emailsProviderConfig.value = model?.EmailsProviderConfig
    })

    watch(isShared, () => {
        if (!isShared.value) {
            location.href = `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${newShareId.value}`
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    (isShared.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, "Shares of " + _toDisplayString(resourceName.value), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_4, [
            _cache[0] || (_cache[0] = _createTextVNode("You shared ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(resourceName.value), 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createTextVNode(" owned by ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
            _cache[2] || (_cache[2] = _createTextVNode(" data in TransparentChoice application", -1 /* CACHED */))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharesExt.value, (s) => {
            return (_openBlock(), _createElementBlock("div", {
              key: s.Id
            }, [
              (s.IsPaused)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(s.Title) + " ", 1 /* TEXT */),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fg-color-orange" }, "(paused)", -1 /* CACHED */)),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("a", null, _toDisplayString(s.ShareUrl), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("a", {
                        href: `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${s.ShareId}`,
                        class: "btn btn-primary pull-right"
                      }, "Manage", 8 /* PROPS */, _hoisted_8)
                    ])
                  ]))
                : (s.Expired)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createTextVNode(_toDisplayString(s.Title) + " ", 1 /* TEXT */),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fg-color-red" }, "(expired)", -1 /* CACHED */)),
                        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("a", null, _toDisplayString(s.ShareUrl), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          href: `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${s.ShareId}`,
                          class: "btn btn-primary pull-right"
                        }, "Manage", 8 /* PROPS */, _hoisted_12)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(s.Title), 1 /* TEXT */),
                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("input", {
                            value: s.Copied ? 'COPIED!' : s.ShareUrl,
                            type: "text",
                            class: _normalizeClass(["form-control bg-white", {'text-success': s.Copied}]),
                            readonly: ""
                          }, null, 10 /* CLASS, PROPS */, _hoisted_16),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (handleCopyToClipboard(s)),
                              class: "btn btn-outline-secondary",
                              type: "button"
                            }, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("span", { class: "fa fa-copy" }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_18)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("a", {
                          href: `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${s.ShareId}`,
                          class: "btn btn-primary mr-1"
                        }, "Manage", 8 /* PROPS */, _hoisted_20),
                        (s.SharedWith?.length>0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: `/#/sharing/share/notification/${s.ShareId}`,
                              class: "btn btn-secondary"
                            }, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("i", { class: "fa-regular fa-paper-plane" }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_21))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])),
              _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1 /* CACHED */))
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: manageUrl.value,
            class: "btn btn-lg btn-secondary mr-1"
          }, "Go to " + _toDisplayString(resourceName.value), 9 /* TEXT, PROPS */, _hoisted_22),
          _createElementVNode("a", {
            href: `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${newShareId.value}`,
            class: "btn btn-lg btn-success pull-right"
          }, "New Share", 8 /* PROPS */, _hoisted_23)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})